import { render, staticRenderFns } from "./UserDetailContactTile.vue?vue&type=template&id=56b27574&scoped=true&lang=pug&"
import script from "./UserDetailContactTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailContactTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailContactTile.vue?vue&type=style&index=0&id=56b27574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b27574",
  null
  
)

export default component.exports